export default __webpack_public_path__ + "static/media/contact.400d0f26.png";